import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { h, reactive, ref } from 'vue';
import { useRouter } from 'vue-router'
import { ElButton, ElTag } from 'element-plus';

import { GbTables } from "@/components/GbTables"
import { TableColumn } from '@/components/GbTables/GbTablesTypes'
import { useGbTable } from '@/hooks/useGbTable'
import { useLocales } from '@/hooks/useLocales'

/* API */
import { GetCompanytListApi, DelCompanyApi } from '@/apis/companys/company.api'
import { CompanySearch, CompanyList } from '@/apis/companys/company.type';
import { assign } from 'lodash';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<CompanyList>({
    getListApi: GetCompanytListApi,
    delListApi: DelCompanyApi,
    response: {
        data: 'data',
        total: 'total'
    }
})

const { getList, setSearchParams } = methods
const { push } = useRouter()

setSearchParams({ tenant_id: 1, code: '' })

const delLoading = ref(false)

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
    { field: 'id', label: t('systems.company.table.companyId', '公司编号'), columnWidth: "200" },
    { field: 'short_name', label: t('systems.company.table.shortName', '公司简称'), columnWidth: "200" },
    { field: 'name', label: t('systems.company.table.companyName', '公司名称'), columnWidth: "240" },
    { field: 'address', label: t('systems.company.table.address', '地址'), align: "left", columnWidth:'auto' },
    { field: 'contact', label: t('systems.company.table.contact', '联系人'), columnWidth: "150" },
    { field: 'phone', label: t('systems.company.table.phone', '联系电话'), columnWidth: "150" },
    { field: 'created_time', label: t('systems.company.table.createdTime', '创建时间'), columnWidth: "120", fixed: 'right' },
    // { field: 'action', width: '180px', label: t('systems.company.table.actions', '操作'), fixed: 'right', align: 'center' }
])


/* 删除数据 */
const deleteDicAction = async (row: TableColumn | null) => {
    await methods.deleteRows(row?.id as string);
}

const createDicAction = () => {
    // push('/systems/dictionary-create')
}

const modifyDicAction = (row: TableColumn) => { }
const getDetailAction = (row: TableColumn) => { }


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"text-align":"left"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              size: "small",
              label: _unref(t)('systems.company.search.departmentName', '部门名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('systems.company.search.buttons.search', '查询')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[0] || (_cache[0] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format("YYYY/MM/DD HH:mm")), 1)
          ]),
          action: _withCtx(({ row }) => [
            _createVNode(_unref(ElButton), {
              type: "primary",
              link: "",
              onClick: ($event: any) => (modifyDicAction(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('systems.company.buttons.edit', '编辑')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_unref(ElButton), {
              type: "success",
              link: "",
              onClick: ($event: any) => (getDetailAction(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('systems.company.buttons.detail', '详细')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_unref(ElButton), {
              type: "danger",
              link: "",
              onClick: ($event: any) => (deleteDicAction(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('systems.company.buttons.delete', '删除')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    })
  ], 64))
}
}

})